import type { SiteControllerSettingBaseFormModel } from "../../../../base/type";
import type { SiteControllerSettingBeds24FormModel } from "../../../type";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
};

export const baseViewModelToViewModelConverter = ({ viewModel: _viewModel }: Props) => {
	const {
		isDirty,
		hasError, //
		hotelID,
		setUpRoomPriceByChillnn,

		beds24AuthenticationApiKey,
		beds24AuthenticationPropKey,
		beds24RoomTypeMapping,
	} = _viewModel;

	const viewModel: SiteControllerSettingBeds24FormModel["ViewModel"] = {
		isDirty,
		hasError,

		hotelID,
		setUpRoomPriceByChillnn,

		beds24AuthenticationApiKey,
		beds24AuthenticationPropKey,
		beds24RoomTypeMapping,
	};

	return { viewModel };
};
